import { render, staticRenderFns } from "./WechatAdReward.vue?vue&type=template&id=493ddf17&scoped=true&lang=pug&"
import script from "./WechatAdReward.vue?vue&type=script&lang=ts&"
export * from "./WechatAdReward.vue?vue&type=script&lang=ts&"
import style0 from "./WechatAdReward.vue?vue&type=style&index=0&id=493ddf17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ddf17",
  null
  
)

export default component.exports